module.exports = __webpack_public_path__ + "img/titles7.e394c093.png";